import {match} from 'ts-pattern';

import {AI_EXTRACTION_BEHAVIOUR} from '../constants/AI_EXTRACTION_BEHAVIOUR';
import {STRUCTURED_INVOICE_BEHAVIOUR} from '../constants/STRUCTURED_INVOICE_BEHAVIOUR';
import {DocumentExtractionBehaviour} from '../types/DocumentExtractionBehaviour';
import {DocumentExtractionMode} from '../types/DocumentExtractionMode';

export const getDocumentExtractionBehaviour = (
  mode: DocumentExtractionMode
): DocumentExtractionBehaviour =>
  match(mode)
    .with('aiExtraction', () => AI_EXTRACTION_BEHAVIOUR)
    .with('structuredInvoice', () => STRUCTURED_INVOICE_BEHAVIOUR)
    .exhaustive();
